import { Area } from '@teko/location';
import { t } from 'i18n';
import { useCallback, useMemo, useState } from 'react';

export type STEP_LOCATION = 'ADDRESS' | 'PROVINCE' | 'DISTRICT' | 'WARD';

export const usePickLocation = ({
  location,
  stepLocation,
  setStepLocation,
  provinces = [],
  wards = [],
}: {
  location: { provinceName: string };
  stepLocation?: STEP_LOCATION;
  setStepLocation?: (stepLocation: STEP_LOCATION) => void;
  provinces: Area[];
  wards: Area[];
}) => {
  const [keyword, setKeyword] = useState('');

  const backToPreviousLevelLocation = () => {
    setStepLocation?.('ADDRESS');
  };

  const originalData = useCallback(() => {
    if (stepLocation === 'PROVINCE') return provinces;

    return wards;
  }, [stepLocation, provinces, wards]);

  const filterLocations = useMemo(() => {
    const data = originalData();
    if (!keyword || keyword === '') return data;
    return (
      data?.filter((option) => {
        return option.title.toLowerCase().includes(keyword.toLowerCase());
      }) || []
    );
  }, [originalData, keyword]);

  const headerText = useMemo(() => {
    if (stepLocation === 'ADDRESS') {
      return {
        title: t('Chọn khu vực của bạn'),
        sutTitle: t('Để biết chính xác tồn kho và thời gian giao hàng'),
        placeHolderSearch: '',
      };
    }

    if (stepLocation === 'PROVINCE') {
      return {
        title: t('Chọn khu vực giao hàng'),
        sutTitle: t('Để biết chính xác tồn kho và thời gian giao hàng'),
        placeHolderSearch: t('Tìm nhanh Tỉnh/ Thành phố'),
      };
    }
    return {
      title: t('Chọn Phường, Xã'),
      sutTitle: `${t('tại')} ${location.provinceName}`,
      placeHolderSearch: t('Tìm nhanh Phường/xã'),
    };
  }, [location, stepLocation]);

  return {
    headerText,
    backToPreviousLevelLocation,
    keyword,
    setKeyword,
    filterLocations,
  };
};
